import { CssFeatureSymbol } from '../../ioc/catharsis-ioc'
import type { MeshCssFeature } from './mesh.types'
import { meshDomApplier } from './meshDomApplier'
import { mesh } from './meshCompNode'
import { meshChild } from './meshChildCompNode'
import { autoHeightWrapper } from '../autoHeightWrapper/autoHeightWrapperCompNode'
import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'
import { compInfoNodes } from '@wix/thunderbolt-component-isolation'

export const meshCssFeature: MeshCssFeature = {
	featureName: 'mesh',
	experimentName: 'OPEN_TO_ALL',
	renderableNodes: { mesh: mesh(false) },
	intermediateNodes: {
		meshChild: meshChild(false),
		autoHeightWrapper,
		hasResponsiveLayout: compInfoNodes.hasResponsiveLayout,
	},
	dataMaps: ['theme_data', 'component_properties', 'document_data', 'layout_data', 'variants_data'],
	domApplier: meshDomApplier,
}

export const editorMeshCssFeature: MeshCssFeature = {
	...meshCssFeature,
	renderableNodes: { mesh: mesh(true) },
	intermediateNodes: {
		meshChild: meshChild(true),
		autoHeightWrapper,
		hasResponsiveLayout: compInfoNodes.hasResponsiveLayout,
	},
}

export const page: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(meshCssFeature)
}

export const editor: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(editorMeshCssFeature)
}
